import { uuidModule } from "@/modules/uuid";
import {
  SpaceAccountNoteModelData,
  SpaceAccountNoteUpsertedSyncUpdateValue,
} from "@/store/recent-items/types";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { IRejectNoteSuggestionOperation } from "@/store/sync/operations/types";
import { SyncModelData, OptimisticSyncUpdate, SyncOperationKind } from "@/store/sync/types";

export class RejectNoteSuggestionOperation extends BaseSyncOperation<IRejectNoteSuggestionOperation> {
  get operationKind(): SyncOperationKind {
    return "REJECT_NOTE_SUGGESTION";
  }

  async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<SyncModelData>[]> {
    const spaceAccountId = this.store.spaceAccounts.myPersonalSpaceAccountId;
    const spaceAccountNoteId = uuidModule.resolveSpaceAccountNoteSyncModelUuid({
      spaceAccountId,
      noteId: this.payload.note_id,
    });
    const spaceAccountNote = await this.store.spaceAccountNotes.getAsync(spaceAccountNoteId);
    if (!spaceAccountNote) return [];

    const spaceAccountNoteUpsertedValue: SpaceAccountNoteUpsertedSyncUpdateValue = {
      model_id: spaceAccountNoteId,
      model_kind: "SPACE_ACCOUNT_NOTE",
      model_version: spaceAccountNote?.modelVersion ?? 0,
      model_data: {
        ...spaceAccountNote.modelData,
        suggestion_data: null,
      },
      model_scopes: spaceAccountNote.modelScopes,
    };
    const spaceAccountNoteUpserted: OptimisticSyncUpdate<SpaceAccountNoteModelData> = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "UPSERTED",
      value: spaceAccountNoteUpsertedValue,
    };
    return [spaceAccountNoteUpserted];
  }

  async triggerRecompute() {
    const spaceAccountId = this.store.spaceAccounts.myPersonalSpaceAccountId;
    const spaceAccountNoteId = uuidModule.resolveSpaceAccountNoteSyncModelUuid({
      spaceAccountId,
      noteId: this.payload.note_id,
    });
    await this.store.spaceAccountNotes.recompute(spaceAccountNoteId);
  }
}
